const disableScroll = () => {
  document.body.style.overflow = "hidden";
};
const enableScroll = () => {
  document.body.style.overflow = "auto";
};

function openOtpLoginPopup (event, popupType, userData = null) {
  event?.preventDefault();
  const otpLoginPopupSection = document.querySelector(
    `.otp-login-popup-section[popup-type="${popupType}"]`
  );
  otpLoginPopupSection.classList.remove("hidden");
  if (userData) {
    updateUserFieldsWithData(otpLoginPopupSection, userData);
  }
  disableScroll();
};

const updateUserFieldsWithData = (sectionHTML, userData) => {
  if(userData?.firstName && typeof userData.firstName === 'string'){
    sectionHTML.querySelector("#ShopifyRegisterForm-FirstName").value =
      userData.firstName;
  }
  if(userData?.lastName && typeof userData.lastName === 'string'){
    sectionHTML.querySelector("#ShopifyRegisterForm-LastName").value =
    userData.lastName;
  }
  if(userData?.cellPhone && typeof userData.cellPhone === 'string'){
    sectionHTML.querySelector("#ShopifyRegisterForm-Phone").value =
    userData.cellPhone;
  }
  if(userData?.email && typeof userData.email === 'string'){
    sectionHTML.querySelector("#ShopifyRegisterForm-email").value =
    userData.email;
  }
};

const closeOtpLoginPopup = (popupType, isEnableScroll) => {
  const otpLoginPopupSection = document.querySelector(
    `.otp-login-popup-section[popup-type="${popupType}"]`
  );
  otpLoginPopupSection.classList.add("hidden");
  clearPopupInputs();
  isEnableScroll && enableScroll();
};

function clearPopupInputs() {
  document.querySelectorAll(".otp-login-popup-section")?.forEach((element) => {
    const inputs = element.querySelectorAll("input");
    inputs.forEach((input) => (input.value = ""));
  });
}

document
  .querySelectorAll(".otp-login-popup-section .overlay")
  ?.forEach((element) => {
    element.addEventListener("click", function () {
      element.closest(".otp-login-popup-section").classList.add("hidden");
      clearPopupInputs();
    });
  });

const toggleLoadingBtn = (popupType) => {
  const button = document.querySelector(
    `[popup-type=${popupType}] .loading-spinner`
  );
  const textButton = document.querySelector(
    `[popup-type=${popupType}] .otp-login-text-submit-btn`
  );
  textButton.classList.toggle("hidden");
  button.classList.toggle("hidden");
};

const translateInputError = (popupType) => {
  let inputs;
  if (popupType === 'birth-kit') {
    inputs = document.querySelectorAll(`#birthKitForm input`);
  } else {
    inputs = document.querySelectorAll(
      `.otp-login-popup-section[popup-type="${popupType}"] input`
    );
  }
 
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    const validity = input.validity;
    if (validity.valueMissing) {
      input.setCustomValidity(input.getAttribute("requiredmessage"));
      return;
    }
    if (
      validity.patternMismatch ||
      validity.tooShort ||
      validity.typeMismatch
    ) {
      input.setCustomValidity(input.getAttribute("formatmessage"));
      return;
    }
    input.setCustomValidity("");
  }
};
